<template>
  <!-- najtrazenije kategorije na pocetnoj: logika klizaca je u ScrollSlider, izgled u assets/scss/topCategory.scss -->
  <ScrollSlider
    :items="categoriesList"
    :title="title"
    :item-key="(cat, index) => cat?.id ?? cat?.price_subcategory_id ?? index"
    item-class="swiper-topcategory-width"
    body-class="topcategories tc-plain"
    frame-class="topcategories__content"
    :btn-prev-class="btnPrevClass"
    :btn-next-class="btnNextClass"
    dots-class="mt-4 swiper-pagination-most"
  >
    <template #item="{ item: cat }">
      <NuxtLink
        v-if="!hasSubcategoryName(cat)"
        :to="routePath({
          name: 'proizvodi-category-subcategory-sort-page',
          params: {
            category: srbTolatPath(cat?.category_name_display),
            subcategory: srbTolatPath(cat?.name_display),
            sort,
            page: 1
          }
        })"
      >
        <div class="topcategoriescard">
          <div class="topcategoriescard__img">
            <NuxtImg
              :src="cat?.img"
              :alt="cat?.name_display + ' – pregled cena na pijacama'"
              width="65"
              height="65"
              loading="lazy"
              decoding="async"
            />
          </div>
          <span class="topcategoriescard__title">
            {{ cat?.name_display }}
          </span>
        </div>
      </NuxtLink>

      <NuxtLink
        v-else
        :to="routePath({
          name: 'cena-na-pijaci-singleproducts',
          params: {
            singleproducts: String(cat?.path ?? '').replace(replaceYearFrom, replaceYearTo)
          }
        })"
      >
        <div class="topcategoriescard">
          <div class="topcategoriescard__img">
            <NuxtImg
              :src="cat?.img"
              :alt="cat?.subcategory_name + ' – pregled cena na pijacama'"
              width="65"
              height="65"
              loading="lazy"
              decoding="async"
            />
          </div>
          <span class="topcategoriescard__title">
            {{ cat?.subcategory_name }}
          </span>
        </div>
      </NuxtLink>
    </template>
  </ScrollSlider>
</template>

<script setup>
import ScrollSlider from '~/components/widgets/Slider/ScrollSlider.vue'

const props = defineProps({
  categories: { type: [Array, Object], default: () => [] },
  title: { type: String, default: 'Najtraženije kategorije' },
  sort: { type: String, default: 'cena' },

  btnNextClass: { type: String, default: 'swiper-button-next-tc' },
  btnPrevClass: { type: String, default: 'swiper-button-prev-tc' },

  replaceYearFrom: { type: String, default: '2026' },
  replaceYearTo: { type: String, default: '2026' },
})

const routePath = useRoutePath()
const { $srbTolat } = useNuxtApp()

const categoriesList = computed(() => {
  if (Array.isArray(props.categories)) return props.categories
  if (props.categories && typeof props.categories === 'object') return Object.values(props.categories)
  return []
})

const hasSubcategoryName = (obj) =>
  !!(obj && Object.prototype.hasOwnProperty.call(obj, 'subcategory_name'))

const srbTolatPath = (text) => {
  if ($srbTolat?.srbTolatPath) return $srbTolat.srbTolatPath(String(text ?? ''))
  return String(text ?? '').toLowerCase().trim().replace(/\s+/g, '-')
}
</script>
